import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('droneFormFields');

    return {
        DRONE_NAME_FIELD_PLACEHOLDER: t('droneNameFieldPlaceholder'),
        FAA_REGISTRATION_NUMBER_FIELD_PLACEHOLDER: t('faaRegistrationNumberFieldPlaceholder')
    };
};

export default useTranslation;
